<template>
    <FormControl
        required
        label="Email"
        :error="
            errors?.getValidationError(
                RequestBodyKeyEnum.App_CompanyUserInvite_Email,
            )
        "
    >
        <TextInput
            type="email"
            :name="RequestBodyKeyEnum.App_CompanyUserInvite_Email"
            required
        />
    </FormControl>
</template>

<script setup lang="ts">
    import type { PropType } from 'vue'
    import ApiFormErrors from '@/Shared/Component/Forms/ApiFormErrors'
    import FormControl from '@/Shared/Component/Forms/FormControl.vue'
    import TextInput from '@/Shared/Component/Forms/TextInput.vue'
    import { RequestBodyKeyEnum } from '@/Shared/AutoGenerated/RequestFieldEnum'

    const props = defineProps({
        errors: {
            type: Object as PropType<ApiFormErrors>,
            required: true,
        },
    })
</script>
